import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import type { RootState } from "redux/store";
import { USER_LOGOUT } from "redux/system.action";

interface LoaderError {
  loaderName: string;
  message: string;
}

interface LoaderErrorState {
  errors: LoaderError[];
}

const initialState: LoaderErrorState = {
  errors: [],
};

const loaderErrorSlice = createSlice({
  name: "loader-errors",
  initialState,
  reducers: {
    addLoaderError: (state, action: PayloadAction<LoaderError>) => {
      state.errors.push(action.payload);
    },
    removeAllLoaderErrors: (state) => {
      state.errors = [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(USER_LOGOUT, () => initialState);
  },
});

export const selectLoaderErrors = (state: RootState) => state.loaderError.errors;

export default loaderErrorSlice;
export const { addLoaderError, removeAllLoaderErrors } = loaderErrorSlice.actions;
